<!-- 表格示范页 -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <vxe-table v-if="columns && columns.length" :auto-resize="true" :resizable="true" show-overflow keep-source
    show-header-overflow size="mini" class="checkbox-table vxe-table" ref="xTable3" :row-class-name="rowClassName"
    :cell-class-name="cellClassName" border :loading="loading" height="100%" width="100%" :export-config="tableExport"
    :show-footer="tableFooter && tableFooter.length > 0" :footer-method="footerMethod" :edit-config="editConfig"
    @edit-closed="editClosedEvent" @cell-click="cellCheckMethod" @cell-dblclick="cellDBLClickEvent"
    :select-config="{ checkMethod: checkControl ? checkMethod : undefined }" @select-all="selectAllEvent"
    @select-change="selectChangeEvent" highlight-current-row @current-change="currentChangeEvent"
    :footer-cell-class-name="footerCellClassName" :customs="customs" :data.sync="tableData">
    <template v-for="(item, index) in columns">
      <vxe-table-column :edit-render="item.editRender || {}" :key="index" :fixed="item.fixed || null"
        :type="item.type || ''" :width="item.width || 0" :min-width="item.minWidth || 0" :field="item.field"
        :title="item.title" :formatter="item.formatter">
        <template v-if="item.editType === 'date'" v-slot:edit="{ row }">
          <div @click.stop="() => { }" style="position: relative">
            <el-date-picker v-model="row[item.field]" :type="item.dateConfig.type || 'date'"
              :format="item.dateConfig.format || 'yyyy-MM-dd'" :value-format="item.dateConfig.valueFormat || 'timestamp'"
              :placeholder="'请选择' + [item.title]">
            </el-date-picker>
          </div>
        </template>
        <template v-else-if="item.editType === 'select'" v-slot:edit="{ row }">
          <el-select v-model="row[item.field]" :placeholder="'请选择' + [item.title]">
            <el-option v-for="op in item.editRender.options" :key="op.value" :label="op.label" :value="op.value">
            </el-option>
          </el-select>
        </template>
        <template v-else-if="item.editType" v-slot:edit="{ row }">
          <el-input v-model="row[item.field]" :type="item.editType" :placeholder="'请输入' + [item.title || '']"></el-input>
        </template>
        <template v-slot:header="{ column }" v-if="item.isSort">
          <div class="flex align-center">
            <span class="mr-5">{{ item.title }}</span>
            <img
              :src="item.sortType === 1 ? '/static/images/jiangxu.png' : item.sortType === 2 ? '/static/images/shengxu.png' : '/static/images/defaultsort.png'"
              @click="onSort(item, index)" style="cursor: pointer" class="icon-16" alt="">
          </div>
        </template>
        <template v-slot="{ row }" v-if="item.editType === 'date'">
          <div class="flex align-center" v-if="isEditAble(row, item.field)">
            <i class="el-icon-date mr-5" style="font-size: 14px; color: #30313a"></i>
            <div class="flex-1" :class="row[item.field] ? 'font-12-30313a' : 'font-12-b9b9b9'">{{ row[item.field] ?
              dateFormat(row[item.field], item.dateConfig.format || 'yyyy-MM-dd') : '请选择' }}</div>
          </div>
          <div v-else>
            <div class="flex-1 font-12-30313a">{{ row[item.field] ? dateFormat(row[item.field], item.dateConfig.format ||
              'yyyy-MM-dd') : '' }}</div>
          </div>
        </template>
        <template v-slot="{ row }" v-else-if="item.editType === 'select' && !item.formatter">
          <div class="flex align-center" v-if="isEditAble(row, item.field)">
            <div class="flex-1" :class="row[item.field] ? 'font-12-30313a' : 'font-12-b9b9b9'">{{row[item.field] ||
              '请选择'}}</div>
            <i class="el-icon-arrow-down mr-5" style="font-size: 14px; color: #30313a"></i>
          </div>
          <div v-else>
            <div class="flex-1 font-12-30313a">{{row[item.field] ===
              null || row[item.field] === undefined ? '' : row[item.field]}}</div>
          </div>
        </template>
        <template v-slot="{ row }"
          v-else-if="item.editType === 'input' || (!item.editType && item.editRender && item.editRender.name === 'input') || item.editType === 'number' || item.editType === 'tel'">
          <div class="flex align-center" v-if="isEditAble(row, item.field)">
            <div class="flex-1" :class="row[item.field] ===
              null || row[item.field] === undefined || row[item.field] === '' ? 'font-12-b9b9b9' : 'font-12-30313a'">
              {{row[item.field] ===
              null || row[item.field] === undefined || row[item.field] === '' ? '请输入' : row[item.field]}}</div>
          </div>
          <div v-else>
            <div class="flex-1 font-12-30313a">{{row[item.field] ===
              null || row[item.field] === undefined ? '' : row[item.field]}}</div>
          </div>
        </template>
        <template v-slot="{ row }" v-else-if="item.isDefine">
          <div class="flex align-center">
            <template v-for="(child, idx) in item.child">
              <div :key="idx" :class="child.className" @click.stop="defineMethod(row, child.methodName)"
                v-if="child.type==='btn' && (!btnShowKey || (btnShowKey && child.showStatus === row[btnShowKey]) || !child.showStatus)">
                {{child.title}}</div>
              <div :key="idx" v-else-if="child.type==='switch'" @click.stop="()=>{}">
                <el-switch :width="30" v-model="row[child.key || item.field]" :active-value="child.activeValue || 1"
                  :inactive-value="child.inactiveValue || 0" @change="defineMethod(row, child.methodName)"
                  active-color="#858585" inactive-color="#e2e2e2">
                </el-switch>
              </div>
              <div class="flex align-center w-100 justify-center" :key="idx" v-else-if="child.type==='radio'"
                @click.stop="()=>{}">
                <el-checkbox :disabled="!isEditAble(row, item.field)" v-model="row[child.key || item.field]"
                  @change="defineMethod(row, child.methodName)" :true-label="child.activeValue || 1"
                  :false-label="child.inactiveValue || 0">
                </el-checkbox>
              </div>
              <div class="flex align-center w-100 justify-center" :key="idx" v-else-if="child.type==='img'"
                @click.stop="()=>{}">
                <el-image v-if="row[child.key || item.field]" style="width: 20px; height: 20px"
                  :src="row[child.key || item.field]" :preview-src-list="[row[child.key || item.field]]">
                </el-image>
              </div>
            </template>
          </div>
        </template>
      </vxe-table-column>
    </template>
  </vxe-table>
</template>

<script>
/* eslint-disable eqeqeq */
import XEUtils from 'xe-utils'

XEUtils.mixin({
  toSex (cellValue) {
    return cellValue == 1 ? '男' : '女'
  },
  toYesOrNo (cellValue) {
    return cellValue == 1 ? '是' : '否'
  },
  toAgree (cellValue) {
    return cellValue == 1 ? '是' : '否'
  },
  toJizhang (cellValue) {
    return cellValue == 1 ? '未记账' : '已记账'
  },
  toQuotaType (cellValue) {
    return cellValue == 1 ? '人工' : cellValue == 2 ? '辅料' : cellValue == 3 ? '机械' : '其他'
  },
  toInventoryStatus (cellValue) {
    return cellValue == 1 ? '未开始' : cellValue == 2 ? '当前期间' : cellValue == 3 ? '结账完成' : ''
  },
  toStatus (cellValue) {
    return cellValue == -1 ? '未确认' : cellValue == 1 ? '已锁定' : cellValue == 2 ? '已确定' : ''
  },
  toTypeBudget (cellValue) {
    return cellValue == 2 ? '材料' : '项目'
  },
  toOrderStatus (cellValue) {
    return cellValue == 1 ? '开单' : cellValue == 2 ? '供应商备货' : cellValue == 3 ? '供应商送货' : cellValue == 4 ? '供应商送货完成' : cellValue == 5 ? '供货完成' : cellValue == 6 ? '已结账' : cellValue == 7 ? '作废 ' : '坏账'
  },
  toOrderType (cellValue) {
    return cellValue == 10 ? '材料入库单' : cellValue == 12 ? '材料入库退单' : cellValue == 11 ? '材料出库单' : cellValue == 13 ? '材料出库退料单' : cellValue == 15 ? '库存报损单' : cellValue == 14 ? '库存报溢单' : ''
  },
  toBillType (cellValue) {
    switch (cellValue) {
      case 'design':
        return '设计费'
      case 'project':
        return '工程款'
      case 'main':
        return '主材款'
      case 'soft':
        return '软装款'
      case 'other':
        return '其他'
      case 'subcontract':
        return '分包款'
      case 'commission':
        return '提成'
      default:
        return ''
    }
  }
})
export default {
  name: 'ErpTable',
  components: {},
  props: ['tableData', 'loading', 'columnData', 'isEdit', 'modifyMethod', 'customs', 'btnShowKey', 'tableFooter',
    'showStatus', 'editableStatus', 'checkControl', 'notCell', 'specialRow', 'confirmMaterial'],
  watch: {
    // 控制某一列是否显示 [{field: 'operate', visible: false}] // 此参数表示操作列不可见
    customs (newVal, oldVal) {
      this.$refs.xTable3.reloadCustoms(newVal)
    },
    tableData () {
      this.$refs.xTable3.clearActived()
    }
  },
  data () {
    return {
      columns: this.columnData,
      // tableDataArr: [],
      editConfig: { showIcon: false },
      operateCol: {},
      tableExport: {
        // 默认选中类型
        type: 'xlsx',
        // 自定义类型
        types: ['xlsx', 'csv', 'html', 'xml', 'txt']
      }
    }
  },
  created () {
    let that = this
    if (this.isEdit) {
      this.editConfig = {
        trigger: 'dblclick',
        mode: 'cell',
        showIcon: false,
        // autoClear: true,
        showStatus: this.showStatus || false,
        activeMethod ({ row, rowIndex, column, columnIndex }) {
          let unEditable = row.unEditable
          if (unEditable && unEditable === 'ALL') {
            return false
          }
          if (that.editableStatus) {
            return (unEditable && unEditable.indexOf(column.property) > -1)
          } else {
            return !(unEditable && unEditable.indexOf(column.property) > -1)
          }
        }
      }
    }
  },
  mounted () { },
  methods: {
    checkMethod ({ row }) {
      if (!this.checkControl) {
        return true
      } else {
        return this.$parent.checkMethod(row)
      }
    },
    currentChangeEvent ({ row }) {
      this.$emit('change-current-row', row)
      console.log('当前事件。。。。')
      this.$refs.xTable3.clearActived()
    },
    exportCsv () {
      this.$refs.xTable3.exportCsv()
    },
    // 表尾合计
    footerCellClassName () {
      return 'font-12-30313a font-bold'
    },
    footerMethod ({ columns, data }) {
      let footer = []
      if (this.tableFooter) {
        for (let i = 0; i < this.tableFooter.length; i++) {
          footer.push(
            columns.map((column, columnIndex) => {
              if (columnIndex === 0) {
                return this.tableFooter[i].name
              }
              if (this.tableFooter[i].columns.includes(column.property)) {
                switch (this.tableFooter[i].type) {
                  case 'mean': // 平均
                    return Number(this.mean(data, column.property)).toFixed(2)
                  case 'sum': // 合计
                    return Number(this.sum(data, column.property)).toFixed(2)
                  default:
                    return null
                }
              }
              return null
            })
          )
        }
      }
      return footer
    },
    mean (data, property) {
      let arr = property.split('.')
      let value = 0
      for (let i = 0; i < data.length; i++) {
        if (arr.length > 1) {
          value += Number(data[i][arr[0]][arr[1]] || 0)
        } else {
          value += Number(data[i][property] || 0)
        }
      }
      return (value / data.length)
    },
    sum (data, property) {
      let arr = property.split('.')
      let value = 0
      for (let i = 0; i < data.length; i++) {
        if (arr.length > 1) {
          value += Number(data[i][arr[0]][arr[1]] || 0)
        } else {
          value += Number(data[i][property] || 0)
        }
      }
      return value
    },
    updateFooter () {
      this.$refs.xTable3.updateFooter()
    },
    isEditAble (row, field) {
      let unEditable = row.unEditable
      if (unEditable && unEditable === 'ALL') {
        return false
      }
      if (this.editableStatus) {
        return (unEditable && unEditable.indexOf(field) > -1)
      } else {
        return !(unEditable && unEditable.indexOf(field) > -1)
      }
    },
    insertAt (record, row, activeCol) {
      this.$refs.xTable3.insertAt(record, row)
        .then(({ row }) => {
          if (activeCol) {
            this.$refs.xTable3.setActiveCell(row, activeCol)
          }
        })
    },
    revertData (row) {
      if (this.$refs.xTable3.revertData) {
        this.$refs.xTable3.revertData(row)
      } else {
        this.$refs.xTable3.revert(row)
      }
    },
    /**
     * 更新列头
     **/
    reloadColumn (columnData) {
      this.$refs.xTable3.reloadColumn(columnData)
    },
    // 设置所有行的选中状态
    setAllSelection (checked) {
      this.$refs.xTable3.setAllSelection(checked)
    },
    selectAllEvent ({ checked }) {
      try {
        if (!checked) {
          this.$emit('select-change', checked)
        }
      } catch (e) {
        console.log(checked ? '所有勾选事件' : '所有取消事件')
      }
    },
    selectChangeEvent ({ checked, row }) {
      try {
        this.$emit('select-change', checked, row)
      } catch (e) {
        console.log(checked ? '勾选事件' : '取消事件')
      }
    },
    rowClassName ({ row, rowIndex }) {
      if (this.specialRow && this.specialRow.length > 0) {
        for (let i = 0; i < this.specialRow.length; i++) {
          if (row[this.specialRow[i].key] == this.specialRow[i].value) {
            return this.specialRow[i].className
          }
        }
      }
    },
    cellClassName ({ row, rowIndex, column, columnIndex }) {
      if (column.property === 'TypeBudget') {
        if (row.TypeBudget == '材料') {
          return 'col-blue'
        }
      }
      if (this.confirmMaterial == 1 && row.specialItem == 'cdy') {
        return 'col-red'
      }
    },
    getSelectEvent () {
      return this.$refs.xTable3.getSelectRecords()
    },
    cellCheckMethod ({ columnIndex, rowIndex }) {
      if (columnIndex > 0 && this.tableData[rowIndex] && !this.notCell) {
        // if (this.definedTemplate && columnIndex < )
        let checked = this.tableData[rowIndex].checked
        this.$refs.xTable3.clearCheckboxRow()
        this.tableData[rowIndex].checked = checked
        this.$refs.xTable3.toggleCheckboxRow(this.tableData[rowIndex])
      }
    },
    cellDBLClickEvent ({ row, rowIndex, column, columnIndex }, event) {
      if (!this.isEdit) {
        console.log(`单元格双击${column.title}`)
        try {
          this.$emit('on-dbl-click', row)
        } catch (e) {
          console.log(e)
        }
      }
    },
    /**
     * 编辑完成
     * @param row
     * @param column
     * @param event
     */
    editClosedEvent ({ row, column }, event) {
      // console.log('编辑完成啦啦啦')
      this.$emit(this.modifyMethod, row, column, column.property)
    },
    defineMethod (row, methodName) {
      this.$emit(methodName, row)
    },
    onSort (column, index) {
      column.sortType = column.sortType === 1 ? 2 : column.sortType === 2 ? 0 : 1
      this.columns[index] = column
      this.$refs.xTable3.refreshColumn()
      this.$emit('on-sort', column, index)
    },
    dateFormat (date, format) {
      // console.log(date)
      return this.Utils.dateFormat(date, format)
    },
    getInsertEvent () {
      return this.$refs.xTable3.getInsertRecords()
    },
    getRemoveEvent () {
      return this.$refs.xTable3.getRemoveRecords()
    },
    getUpdateEvent () {
      return this.$refs.xTable3.getUpdateRecords()
    },
    removeSelecteds () {
      this.$refs.xTable3.removeSelecteds()
    },
    remove (row) {
      this.$refs.xTable3.remove(row)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/ErpTable.vue